import React, { useContext, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { saveStatusCargoRealName, deleteCargoRealName, updateCargoRealName } from 'actions/cargoes/realNames';
import { Dialog, FlatButton, MenuItem, Popover, RaisedButton, SelectField, TableRow, TableRowColumn, TextField } from 'material-ui';
import ModalEditRow from './ModalEditRow';
import styles from 'styles';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import Tags from './Tags';
import _ from 'lodash';
import api from 'services';
import { IsCargoesFromUsersContext, HandleToggleConvertDialogContext } from './RealNamesTable';

/**
 * @param {RealNamesRowProps} prop0
 * @returns 
 */
function RealNamesRow({ 
    item: _item, SEARATES_CATEGORIES, cargoTypes,
    deleteCargoRealName, updateCargoRealName, saveStatusCargoRealName,
}) {
    const [isModalEditOpened, setIsModalEditOpened] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [textDialog, setTextDialog] = useState('');
    const [item, setItem] = useState(_item);
    const isCargoesFromUsers = useContext(IsCargoesFromUsersContext);
    const handleToggleConvertDialog = useContext(HandleToggleConvertDialogContext);

    const handleCancelDelete = () => {
        setOpenDeleteDialog(!openDeleteDialog);
        setTextDialog('');
    };

    const toggleModalEdit = () => {
        setIsModalEditOpened(!isModalEditOpened);
    };

    const handleDeleteItem = () => {
        setOpenDeleteDialog(false);
        setTextDialog('');

        deleteCargoRealName(item);
    };

    const checkIfUpdate = (itemToCheck) => {
        if (itemToCheck.name === '') {
            return false;
        }
        
        const isChecked = cargoTypes.find((cargoType) => {
            if (itemToCheck.parent.red) {
                return itemToCheck.parent.red.name === cargoType.name;
            }
           
            return true;
        });
        
        return !!isChecked;
    };

    const inputCargoName = (value) => {
        const clonedItem = _.cloneDeep(item);
        
        clonedItem.name = value;
        clonedItem.isUpdate = checkIfUpdate(item);

        setItem(clonedItem);
    };

    const blurCargoName = () => {
        saveStatusCargoRealName(item);
    };

    const handleChangeCargoType = (itemName) => {
        const clonedItem = _.cloneDeep(item);
        const newCargoType = cargoTypes.filter(cargoName => cargoName.name === itemName);
        
        if (clonedItem.parent.red) {
            clonedItem.parent.red.name = newCargoType[0].name;
            clonedItem.parent.red._id = newCargoType[0]._id;
        } else {
            clonedItem.parent.red = {
                name: newCargoType[0].name,
                _id: newCargoType[0]._id,
            };
        }

        clonedItem.isUpdate = checkIfUpdate(clonedItem);

        setItem(clonedItem);
        saveStatusCargoRealName(clonedItem);
    };

    const handleChangeDetail = (value) => {
        const clonedItem = _.cloneDeep(item);
        
        clonedItem.details = value;
        clonedItem.isUpdate = checkIfUpdate(clonedItem);

        setItem(clonedItem);
        saveStatusCargoRealName(clonedItem);
    };

    const handleUpdateCargoName = () => {
        const clonedItem = _.cloneDeep(item);
        clonedItem.isUpdate = false;

        setItem(clonedItem);
        updateCargoRealName(clonedItem);
    };

    const handleOpenDeleteDialog = () => {
        api.checkForDeleteCargoName(item)
            .then((response) => {
                if (response.data.data.status === 200) {
                    setOpenDeleteDialog(true);
                    setTextDialog(`Found ${response.data.data.counter} requests.`);
                }
            });
    };
    
    const handleChangeSf = (value) => {
        const clonedItem = _.cloneDeep(item);
        clonedItem.sf = { user: value };

        clonedItem.isUpdate = checkIfUpdate(clonedItem);

        setItem(clonedItem);
        saveStatusCargoRealName(clonedItem);
    };

    const actionsDelete = [
        <FlatButton
            label='Cancel'
            primary
            onClick={handleCancelDelete}
        />,
        <FlatButton
            label='Submit'
            primary
            onClick={handleDeleteItem}
        />,
    ];

    return (
        <TableRow
            key={`realNames_${item._id}`}
        >
            {
                isModalEditOpened ? <ModalEditRow 
                    isDialogOpened={isModalEditOpened}
                    toggleDialog={toggleModalEdit}
                    data={item}
                    SEARATES_CATEGORIES={SEARATES_CATEGORIES}
                    key={Date.now()}
                /> : null
            }
            {
                openDeleteDialog ? 
                    <Dialog
                        title='Do you want to delete?'
                        actions={actionsDelete}
                        modal={false}
                        open={openDeleteDialog}
                        onRequestClose={handleCancelDelete}
                    >
                        {textDialog}
                    </Dialog> : null
            }
            <TableRowColumn 
                style={{
                    ...styles.tableRowColumnCSS, height: '54px', width: '20%', maxWidth: 'unset', 
                }}
                className='cargo-realnames_name_column'
            >
                <TextField
                    value={item.name}
                    hintText='realCargoName'
                    onChange={e => inputCargoName(e.target.value)}
                    onBlur={blurCargoName}
                    style={{ ...styles.textField, width: '57%' }}
                />

                <CheckCircle 
                    style={{ margin: '0 0 -7px 10px', display: item.hasSeaRates ? 'inline-block' : 'none' }}
                    color='#00BAD1'
                />
                <span className='btn-update hide'>
                    <RaisedButton 
                        label='More'
                        onClick={toggleModalEdit}
                        labelStyle={{ fontSize: '11px' }}
                        style={{
                            margin: '0 0 0 10px', lineHeight: '25px', height: '25px', minWidth: '62px', 
                        }}
                        buttonStyle={{ lineHeight: '25px', height: '25px' }}
                        primary
                    />
                </span>
            </TableRowColumn>

            <TableRowColumn style={{ ...styles.tableRowColumnCSS, width: '20%', maxWidth: 'unset' }}>
                <SelectField
                    style={{ ...styles.selectFieldCSS, display: 'block' }}
                    value={item.parent.red ? item.parent.red.name : null}
                    onChange={(_e, _i, v) => handleChangeCargoType(v)}
                    maxHeight={200}
                    autoWidth
                >
                    {
                        cargoTypes.map((cargoCategoryName, index) => (
                            <MenuItem 
                                key={`${cargoCategoryName.name}_${index}`} 
                                style={styles.menuItemCSS} 
                                value={cargoCategoryName.name} 
                                primaryText={cargoCategoryName.name} 
                            />
                        ))
                    }
                </SelectField>
            </TableRowColumn>
        
            <TableRowColumn style={{ ...styles.tableRowColumnSmallCSS, width: '10%', maxWidth: 'unset' }}>
                <SelectField
                    style={{ ...styles.selectFieldCSS, display: 'block' }}
                    value={item.details}
                    onChange={(_e, _i, v) => handleChangeDetail(v)}
                    maxHeight={200}
                    autoWidth
                >
                    <MenuItem style={styles.menuItemCSS} value={1} primaryText={1} />
                    <MenuItem style={styles.menuItemCSS} value={2} primaryText={2} />
                    <MenuItem style={styles.menuItemCSS} value={3} primaryText={3} />
                    <MenuItem style={styles.menuItemCSS} value={4} primaryText={4} />
                    <MenuItem style={styles.menuItemCSS} value={5} primaryText={5} />
                    <MenuItem style={styles.menuItemCSS} value={6} primaryText={6} />
                    <MenuItem style={styles.menuItemCSS} value={7} primaryText={7} />
                    <MenuItem style={styles.menuItemCSS} value={8} primaryText={8} />
                    <MenuItem style={styles.menuItemCSS} value={9} primaryText={9} />
                    <MenuItem style={styles.menuItemCSS} value={10} primaryText={10} />
                    <MenuItem style={styles.menuItemCSS} value={11} primaryText={11} />
                    <MenuItem style={styles.menuItemCSS} value={12} primaryText={12} />
                    <MenuItem style={styles.menuItemCSS} value={13} primaryText={13} />
                    <MenuItem style={styles.menuItemCSS} value={14} primaryText={14} />
                    <MenuItem style={styles.menuItemCSS} value={15} primaryText={15} />
                </SelectField>
            </TableRowColumn>

            <TableRowColumn style={{ ...styles.tableRowColumnSmallCSS, width: '7%' }}>
                <TextField
                    value={item.sf ? item.sf.user : null}
                    hintText='SF'
                    onChange={e => handleChangeSf(parseFloat(e.target.value))}
                    onBlur={blurCargoName}
                    style={{ ...styles.textField, width: '57%' }}
                    type='number'
                />
            </TableRowColumn>
        
            <TableRowColumn style={{
                ...styles.tableRowColumnCSS, overflow: 'unset', width: '20%', maxWidth: 'unset', 
            }}
            >
                <Tags 
                    key={`realNames_${item._id}_tag`}
                    cargoId={item._id}
                    cargoName={item.name}
                    cargoDetails={item.details}
                    initialTags={item.tags || []}
                />
            </TableRowColumn>

            <TableRowColumn style={{
                ...styles.tableRowColumnCSS, 
                overflow: 'unset',
                display: 'flex', 
                gap: '10px', 
                maxWidth: 'unset', 
                height: '54px',
                alignItems: 'center',
                width: '23%',
            }}
            >
                <div style={{ visibility: item.isUpdate ? 'visible' : 'hidden' }}>
                    <RaisedButton
                        label='Update'
                        primary
                        onClick={handleUpdateCargoName}
                    />
                </div>
                <RaisedButton
                    label='To admin'
                    backgroundColor='#F8BF50'
                    labelStyle={{ padding: '0 6px' }}
                    onClick={() => handleToggleConvertDialog(item._id)}
                    style={{
                        visibility: isCargoesFromUsers ? 'visible' : 'hidden',
                    }}
                />
                <RaisedButton
                    label='Delete'
                    secondary
                    onClick={handleOpenDeleteDialog}
                />
            </TableRowColumn>
        </TableRow>
    );
}

export default React.memo(connect(
    null,
    dispatch => bindActionCreators(
        {
            deleteCargoRealName,
            updateCargoRealName,
            saveStatusCargoRealName,
        },
        dispatch,
    ),
)(RealNamesRow));

/**
 * item
 * @typedef {Object} RealNamesItemProps
 * @property {string} name 
 * @property {string} _id
 * @property {any[]} tags
 * @property {number} details
 * @property {boolean} isUpdate
 * @property {{ user: number }} [sf]
 */

/**
 * props
 * @typedef {Object} RealNamesRowProps
 * @property {RealNamesItemProps} item 
 * @property {any[]} SEARATES_CATEGORIES
 * @property {any[]} cargoTypes
 * @property {Function} deleteCargoRealName
 * @property {Function} updateCargoRealName
 * @property {Function} saveStatusCargoRealName
 */




// WEBPACK FOOTER //
// ./app/components/Cargoes/RealNames/RealNamesRow.jsx